import script from "./SponsorComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SponsorComponent.vue?vue&type=script&setup=true&lang=js"

import "./SponsorComponent.vue?vue&type=style&index=0&id=047c603e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-047c603e"]])

export default __exports__